import type { ButtonBaseProps, TooltipProps } from '@mui/material';
import { ButtonBase, Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { darken } from '@mui/material/styles';

export type TooltipIconButtonProps = {
  title: string;
  sx?: SxProps<Theme>;
  tooltipProps?: Omit<TooltipProps, 'title' | 'children'>;
} & Omit<ButtonBaseProps, 'title' | 'aria-label'>;

export function TooltipIconButton({
  title,
  sx,
  tooltipProps,
  children,
  ...buttonProps
}: TooltipIconButtonProps) {
  return (
    <Tooltip
      title={title}
      {...tooltipProps}
    >
      <ButtonBase
        aria-label={title}
        sx={theme => ({
          backgroundColor: 'gx.response',
          height: 48,
          minWidth: 20,
          p: 0,
          borderRadius: 0,
          transition: 'background-color 0.13s ease',
          svg: {
            fontSize: theme.typography.pxToRem(12)
          },
          '&:hover > .MuiSvgIcon-root': {
            color: 'white'
          },
          ':hover': {
            backgroundColor: darken(theme.palette.gx.response, 0.15)
          },
          ...((typeof sx === 'function' ? sx(theme) : sx) as any)
        })}
        {...buttonProps}
      >
        {children}
      </ButtonBase>
    </Tooltip>
  );
}

export default TooltipIconButton;
